/*---------------------------------------------------------------------------------------------
* Copyright (c) Bentley Systems, Incorporated. All rights reserved.
* See LICENSE.md in the project root for license terms and full copyright notice.
*--------------------------------------------------------------------------------------------*/

import { To } from "react-router-dom";

export interface SandboxNavigation {
  userName: string;
  sandboxName: string;
  file?: string;
  start?: string;
  end?: string;
  focusTag?: string;
  focus?: boolean;
  embed?: boolean;
};

const convertParams = (args: { [key: string]: any }) => {
  const params: Record<string, string> = {};
  for (const item of Object.keys(args)) {
    if (args[item] !== undefined)
      params[item] = args[item].toString();
  }
  return params;
};

/// Defines standard navigation routes, to be used in router.navigate() method
export const routeTo = {
  sandbox: ({ userName, sandboxName: codeshareName, ...args }: SandboxNavigation): To => {
    const urlParams = new URLSearchParams(convertParams(args));

    return {
      pathname: `/${userName}/${codeshareName}`,
      search: urlParams.toString(),
    };
  },
  new: (): To => {
    return {
      pathname: `/new`,
    };
  },
  search: (term: string) => {
    const urlParams = new URLSearchParams({ term: encodeURIComponent(term) });
    return {
      pathname: `/search`,
      search: urlParams.toString(),
    };
  },
};
